import React from "react";
import ContentInputsTypesEnum from "../../../../enums/ContentInputsTypesEnum";
import DebouncedInput from "../../../DebouncedInput";
import { useCurrentInputData } from "../useCurrentInputData";

interface Props {
  item: any;
  keyProp: number;
  saveContentInStore: any;
  generator: any;
  contentType: ContentInputsTypesEnum;
  currentInputData: any;
  toggleNewEditionsDetected: (value: boolean) => void;
}

const StepTitleField = (props: Props): JSX.Element => {
  const {
    item,
    saveContentInStore,
    generator,
    contentType,
    currentInputData,
    keyProp,
    toggleNewEditionsDetected,
  } = props;
  const currentInputDataRef = useCurrentInputData(currentInputData);

  const onChangeStepTitleHandler = (value: any) => {
    saveContentInStore(
      generator.changeStepTitle(
        { [contentType]: currentInputDataRef.current },
        keyProp,
        value
      )
    );
    toggleNewEditionsDetected(true);
  };

  if (!currentInputDataRef.current.hasTitle) return null;

  return (
    <DebouncedInput
      className="content-input__input"
      onChange={onChangeStepTitleHandler}
      defaultValue={item.title}
      placeholder="Enter step title"
    />
  );
};

export default StepTitleField;
